import Flex from '@deprecated-ui/common/Flex';
import Text from '@deprecated-ui/common/Text';
import Button from '@deprecated-ui/common/Button';
import Iconmoon, { IconWrapper } from '@deprecated-ui/common/Iconmoon';
import color from '@deprecated-ui/_style/color';
import If from 'global/ErrorHandlers/If';
import { useDispatch, useSelector } from 'react-redux';
import {
  selectors as watchlistSelector,
  effects as watchlistEffects,
} from 'lib/entities/watchlist';
import { useEffect, useState } from 'react';
import { Modal } from '../styled';
import CreateWatchlist from './CreateWatchlist';
import SkeletonList from './SkeletonList';
import { Divider } from './styled';

interface ModalCompanyProps {
  companyId: number;
  visible: boolean;
  onCancel: () => void;
  onFollow?: (following: boolean) => void;
  [key: string]: any;
}

function ModalCompanyWatchlist({
  companyId,
  visible,
  onCancel,
  onFollow = () => {},
  ...props
}: ModalCompanyProps) {
  const dispatch = useDispatch();
  const {
    symbol: { data: watchlistCompany, isLoading, error },
  } = useSelector(watchlistSelector);
  const [currentCompanyId, setCurrentCompanyId] = useState<number>(0);
  const watchListData: Array<any> = watchlistCompany[currentCompanyId] || [];

  useEffect(() => {
    if (companyId !== currentCompanyId) {
      dispatch(watchlistEffects.getCompanyWatchlist(companyId));
      setCurrentCompanyId(companyId);
    }
  }, [companyId]);

  const handleFollow = async (id, followed, index) => {
    const type = followed ? 'UNFOLLOW' : 'FOLLOW';
    const params = {
      companyId,
      watchlistId: id,
      type,
    };

    // @ts-ignore
    const follow = await dispatch(watchlistEffects.followCompany(params));

    // @ts-ignore
    // eslint-disable-next-line @typescript-eslint/no-shadow
    const { error, data } = follow.payload;

    if (!error) {
      // dispatch(watchlistEffects.getCompanyWatchlist(companyId));

      if (onFollow) {
        // If follow -> return true
        // If unfollow, but index !== 0 -> still return true, bcs still listed in `All Watchlist`
        // if unfollow and index === 0 -> return false
        const statusFollowing = type === 'FOLLOW' ? true : index !== 0;

        onFollow(statusFollowing);
      }
    }
  };

  return (
    <Modal
      {...props}
      // @ts-expect-error
      noBorder
      visible={visible}
      onCancel={onCancel}
      centered
      title={
        // eslint-disable-next-line react/jsx-wrap-multilines
        <Text
          size="18px"
          height="52px"
          family="bold"
          align="center"
          color={color.suvaGray}
        >
          Save to Watchlist
        </Text>
      }
      footer={null}
    >
      <CreateWatchlist companyId={currentCompanyId} />
      <Divider />

      <div style={{ maxHeight: 280, height: '280px', overflowY: 'auto' }}>
        <If condition={!watchListData.length || isLoading}>
          <SkeletonList />
        </If>
        <If condition={!isLoading}>
          {watchListData.map(
            ({ watchlist_id: id, name, followed }, idx) => (
              <Flex
                key={id}
                height="40px"
                align="center"
                justify="space-between"
              >
                <Text size="16px">{name}</Text>
                <Button
                  // @ts-expect-error
                  p="0px"
                  type={followed ? 'primary' : 'default'}
                  onClick={() => handleFollow(id, followed, idx)}
                >
                  <IconWrapper padding="3px">
                    <Iconmoon
                      className={`icon-toolbar_${
                        followed ? 'check' : 'plus'
                      }`}
                      color={followed ? color.light : color.dimgray}
                      size="14px"
                      hoverColor={followed ? color.light : color.dimgray}
                    />
                  </IconWrapper>
                </Button>
              </Flex>
            ),
          )}
        </If>
      </div>
    </Modal>
  );
}

export default ModalCompanyWatchlist;
